import React from 'react';
import { datasetSubscriptions } from '@/notifications/subscribers/constants';
import { firstError } from '@/utils/errors';
import ErrorMessage from '@/components/errors/ErrorMessage';
import DatasetSubscribeMessage from './DatasetSubscribeMessage';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import Fetch from '../hooks/fetch';

const DatasetSubscribeMessageContainer = ({ category, code }) => {
  const state = Selectors.useDatasetSubscribeMessageContainer({ category, code });
  const subscribe = Events.useSubscribeToRequestDataset(category, { code });
  Fetch.useRequestUserSubscriptions({ category, code }, state.readStatus);
  const error = firstError(state.errors);

  if (error) { return (<ErrorMessage className="aridhia-dataset-subscribe-error-message" error={error} />); }
  if (!state.canSubscribe) { return null; }

  return (
    <DatasetSubscribeMessage
      event={datasetSubscriptions.DATASET_UPDATE}
      name={state.name}
      onClick={subscribe}
      saveStatus={state.saveStatus}
      subscribed={state.subscribed}
    />
  );
};

export default DatasetSubscribeMessageContainer;
